import React from "react";
import './Layout.css';

export function BasicTopBar() {
    return(
        <div id="top-bar" className={window.env.DISPLAY_ENVIRONMENT}>
        <div className="bar-layout">
            <div>
                <img
                    alt="Vision logo"
                    id="logo"
                    src={
                        window.env.DISPLAY_ENVIRONMENTt !== ""
                            ? "/images/vision-logo-white.svg"
                            : "https://vision.fta.co.uk/Content/images/svg/vision-logo.svg"
                    }
                />
            </div>
        </div>
    </div>
    )
}